/* Wynden Home — блок выбора наборов (#whs6) и гравировки (#whs7).
   Вынесен из блока Custom Liquid: у настройки Custom Liquid лимит ~49 000 символов,
   и блок в него перестал помещаться. Разметка и стили остались в Custom Liquid,
   все настройки приходят сюда через data-атрибуты #whs7. */
(function () {
  var box6 = document.getElementById('whs6');
  var box7 = document.getElementById('whs7');
  if (!box6 || !box7) return;

  /* ---- тексты на языке страницы ----
     Блок Custom Liquid кладёт рядом <script type="application/json" id="wh-i18n-eng">
     со строками из locales/*.json (wh.js.*). EN — запасной вариант, если блока нет.
     Фильтр t экранирует HTML, поэтому значения раскодируются через textarea. */
  var EN = {"confirm_spelling": "Please confirm the spelling.", "ideas": "For Mom, with love||center;For Grandma,|from us|right;For Dad,|the real chef|center;Sarah's kitchen||center;The Millers,|est. 2026|right;Emma & Jack \u2665 2026||center;Happy Birthday,|Anna|center;Welcome home,|Olivia|center;Chef James||center;Grandma|Rose's kitchen|center", "set_n": "SET {n}", "your_text": "YOUR TEXT", "personalize": "Personalize", "keep_logo": "Keep our logo", "placeholder_1": "For Mom, with love", "placeholder_2": "from Anna and Tom", "aria_text": "Engraving text", "note": "Press Enter for a second line. Up to {lines} lines, {max} characters each. Add spaces to shift a line. Symbols like \u2665 \u2605 & are welcome.", "align": "ALIGN", "align_left": "Align left", "align_center": "Center", "align_right": "Align right", "smaller": "Smaller", "bigger": "Bigger", "text_size": "Text size", "idea": "Need an idea?", "font": "Choose your font", "font_classic": "Classic", "font_serif": "Serif", "font_modern": "Modern", "font_script": "Script", "preview_alt": "Engraving preview", "edge": "The dotted area is the engraving field. Longer text is engraved smaller. The final result is adjusted by hand to each piece of wood.", "text_here": "Your text here", "limit": "Engraving is available for up to {n} sets per order. For more, place a separate order \u2014 or turn engraving off.", "up_to_sets": "UP TO {n} SETS", "free": "FREE", "enter_text_set": "Enter the text for set {n}.", "enter_text": "Enter your engraving text.", "hint_lines": "Up to {lines} lines, {max} characters each.", "wait": "Please keep this page open. It usually takes a few seconds.", "ship_b": "Free delivery, 8\u201318 business days", "ship_em": "Duty prepaid \u00b7 Nothing to pay on delivery", "adv": "Not sure what your current set is made of? Read this first \u2192", "preparing": "Preparing your engraving\u2026", "preparing_n": "Preparing your engraving\u2026 {a} of {b}", "adding": "Adding to your bag\u2026", "opening": "Opening your bag\u2026", "ship_msg": "We could not add that to your bag. We ship to the United States, Canada, Australia, New Zealand, Mexico and the United Arab Emirates. If you are in one of those and still see this, please email support@wyndenhome.com."};
  var I18N = {};
  try { I18N = JSON.parse((document.getElementById('wh-i18n-eng') || {}).textContent || '{}') || {}; } catch (e) { I18N = {}; }
  var decBox = document.createElement('textarea');
  function T(k, vars) {
    var v = I18N[k];
    if (v == null || v === '' || String(v).indexOf('translation missing') === 0 || String(v).indexOf('Translation missing') === 0) v = EN[k] != null ? EN[k] : k;
    decBox.innerHTML = String(v);
    v = decBox.value;
    if (vars) Object.keys(vars).forEach(function (n) { v = v.split('{' + n + '}').join(vars[n]); });
    return v;
  }
  function escH(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function TH(k, vars) { return escH(T(k, vars)); }
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Цены: формат берём у магазина (он зависит от валюты рынка), а не рисуем «$» сами. */
  var MONEY_FMT = box7.getAttribute('data-money') || '${{amount}}';
  /* Тот же формат без кода валюты — для зачёркнутых цен и доплаты, чтобы не дублировать «CAD». */
  var MONEY_PLAIN = box7.getAttribute('data-money-plain') || MONEY_FMT;

  var UNIT   = Number(box7.getAttribute('data-unit')) || 0;
  var CMP1   = Number(box7.getAttribute('data-cmp1')) || 0;
  var OFF2   = Number(box7.getAttribute('data-off2')) || 0;
  var OFF3   = Number(box7.getAttribute('data-off3')) || OFF2;
  var MAX    = Number(box7.getAttribute('data-max')) || 25;
  var ENG_ID = Number(box7.getAttribute('data-eng-id')) || 0;
  var ENG_FREE_ID = 0;
  var engReady = fetch('/products/personalized-engraving.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (p) {
      (p.variants || []).forEach(function (v) { if (v.price === 0 && !ENG_FREE_ID) ENG_FREE_ID = v.id; });
    })
    .catch(function () {});
  var SET_ID = Number(box7.getAttribute('data-set-id')) || 0;
  var FEE_C  = Number(box7.getAttribute('data-fee')) || 2000;
  var IMG    = box7.getAttribute('data-img') || '';
  var KEY    = 'wh-eng2-' + (box7.getAttribute('data-key') || 'set');
  var MAXSETS = 10;
  // Цена гравировки за набор — та же, что у платного варианта (в валюте рынка).
  var ENG_COMPARE_PER_SET_C = FEE_C;

  // Подарок из окна (wh-exit-offer.js): cookie wh_exit_offer_claimed.
  function giftOn() {
    try { return /(?:^|;\s*)wh_exit_offer_claimed=1(?:;|$)/.test(document.cookie); }
    catch (e) { return false; }
  }
  // Любые буквы, цифры, знаки, значки и эмодзи. Убираем только служебные невидимые символы.
  var CMSG = T('confirm_spelling');
  var BAD    = /[\p{Cc}\p{Co}\p{Cs}\u00AD\u200B\u2060\uFEFF\uFE00-\uFE0F]/gu;
  var MAXLINES = 2;
  var BOXH   = 0.339;

  /* Подсказки: строка 1, строка 2, выравнивание. Нажатие подставляет готовую
     раскладку — человеку остаётся поменять только имя. */
  var IDEAS = T('ideas').split(';').map(function (row) {
    var p = row.split('|');
    return [p[0] || '', p[1] || '', p[2] || 'center'];
  }).filter(function (p) { return p[0]; });

  /* Шрифты гравировки. Покупатель выбирает один; превью, фото в корзине и макет
     для фабрики рисуются им же, название уходит в свойства заказа.
     k — запас по высоте, wk — по ширине: у рукописного шрифта завитки выходят
     за кегль, и без запаса их срезало бы краем поля гравировки. */
  var FONT_TAIL = '"Noto Sans Symbols 2", "Noto Emoji", "Noto Sans", "Noto Sans Arabic", Jost, system-ui, serif';
  var FONTS = [
    { id: 'classic', name: 'Classic', fam: 'Cormorant Garamond', style: 'italic', weight: 600, k: 1, wk: 1 },
    { id: 'serif',   name: 'Serif',   fam: 'Playfair Display',   style: 'normal', weight: 500, k: 0.9, wk: 1 },
    { id: 'modern',  name: 'Modern',  fam: 'Montserrat',         style: 'normal', weight: 500, k: 0.9, wk: 1 },
    { id: 'script',  name: 'Script',  fam: 'Dancing Script',     style: 'normal', weight: 700, k: 0.9, wk: 0.96 }
  ];
  function fontOf(s) {
    var id = s && s.font;
    for (var i = 0; i < FONTS.length; i++) if (FONTS[i].id === id) return FONTS[i];
    return FONTS[0];
  }
  function fontCss(F) { return '"' + F.fam + '", ' + FONT_TAIL; }
  function fontLoadSpec(F) { return F.style + ' ' + F.weight + ' 40px "' + F.fam + '"'; }

  var on    = document.getElementById('whs7-on');
  var okcb  = document.getElementById('whs7-ok');
  var diff  = document.getElementById('whs7-diff');
  var diffW = box7.querySelector('[data-whs7-diffwrap]');
  var fee   = box7.querySelector('[data-whs7-fee]');
  var wrap  = box7.querySelector('[data-whs7-sets]');
  var blk   = box7.querySelector('[data-whs7-block]');
  var prog  = box7.querySelector('[data-whs7-prog]');
  var head  = box7.querySelector('.whs7-head');
  var sum   = box6.querySelector('.whs6-sum');

  /* Ползунок — доля от самого крупного размера, который помещается в поле.
     100% = максимум для этой надписи, 0% = SCALE_MIN от него. Поэтому новый набор
     начинается со 100%: покупателю почти всегда нужен самый крупный текст. */
  var SCALE_MIN = 0.45;
  function frac(v) { return SCALE_MIN + (Math.max(0, Math.min(100, Number(v) || 0)) / 100) * (1 - SCALE_MIN); }
  function fresh() { return { mode: 'text', l1: '', l2: '', v1: 100, v2: 100, hasL2: false, eg: false, al: 'center', font: 'classic', fo: true }; }
  var st = [];
  for (var z = 0; z < MAXSETS; z++) st.push(fresh());
  var lastKey = -1;

  function save() {
    try {
      localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), on: on.checked, diff: diff.checked, ok: okcb.checked, qty: qty(), st: st }));
    } catch (e) {}
  }
  function load() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!d || !d.t || Date.now() - d.t > 2 * 86400000) return null;
      return d;
    } catch (e) { return null; }
  }
  function forget() { try { localStorage.removeItem(KEY); } catch (e) {} }

  function money(c, plain) {
    var v = c / 100;
    function fmt(dec, th, dp) {
      var p = v.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(dp);
    }
    var done = false;
    var out = (plain ? MONEY_PLAIN : MONEY_FMT).replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      done = true;
      switch (key) {
        case 'amount_no_decimals': return fmt(0, ',', '.');
        case 'amount_with_comma_separator': return fmt(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        case 'amount_with_space_separator': return fmt(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(0, ' ', ',');
        default: return fmt(2, ',', '.');
      }
    });
    return done ? out : '$' + fmt(2, ',', '.');
  }
  function scope() { return box6.closest('.shopify-section') || box6.closest('[id^="shopify-section"]') || document; }
  function qtyInput() {
    return [].slice.call(document.querySelectorAll('input[name="quantity"]')).filter(function (i) {
      return i.type !== 'hidden' && !box6.contains(i) && !box7.contains(i);
    })[0] || null;
  }
  function qty() {
    var i = qtyInput();
    var n = i ? parseInt(i.value, 10) : 1;
    if (!n || n < 1) n = 1;
    if (n > 3) n = 3; // не больше трёх наборов в заказе
    return n;
  }
  function setQty(n) {
    var i = qtyInput();
    if (!i) return;
    if (i.value !== String(n)) {
      i.value = n;
      i.dispatchEvent(new Event('input', { bubbles: true }));
      i.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function productForm() {
    return [].slice.call(document.querySelectorAll('form[action*="/cart/add"]')).filter(function (f) {
      var id = f.querySelector('[name="id"]');
      return id && id.value && !box7.contains(f);
    })[0] || null;
  }
  function submitBtn() { var f = productForm(); return f ? f.querySelector('[type="submit"]') : null; }
  function clean(v) { return Array.from(String(v || '').replace(/[\r\n\t]+/g, ' ').replace(BAD, '')).slice(0, MAX).join(''); }
  function clen(t) { return Array.from(t || '').length; }
  /* Текст из поля → не больше MAXLINES строк по MAX символов.
     Длинная строка сама переносится по последнему пробелу. */
  function wrapText(v) {
    var src = String(v || '').replace(/\r/g, '').replace(/\t/g, ' ').split('\n');
    var out = [], cut = false;
    src.forEach(function (line) {
      var ch = Array.from(line.replace(BAD, ''));
      while (ch.length > MAX) {
        var head = ch.slice(0, MAX + 1), sp = head.lastIndexOf(' ');
        if (sp > 0) { out.push(ch.slice(0, sp).join('')); ch = ch.slice(sp + 1); }
        else { out.push(ch.slice(0, MAX).join('')); ch = ch.slice(MAX); }
      }
      out.push(ch.join(''));
    });
    if (out.length > MAXLINES) { cut = out.slice(MAXLINES).join('').trim() !== ''; out = out.slice(0, MAXLINES); }
    return { lines: out, cut: cut };
  }
  function areaText(s) { return s.l1 + (s.hasL2 ? '\n' + s.l2 : ''); }
  function tooMany() { return qty() > MAXSETS; }
  function multi() { return qty() >= 2 && qty() <= MAXSETS && diff.checked; }
  function panels() { return multi() ? qty() : 1; }

  function syncRadios() {
    var n = qty();
    box6.querySelectorAll('input[name="whs6-pick"]').forEach(function (r) {
      r.checked = Number(r.value) === n;
      // Запасной вариант для Safari до 15.4, где не работает CSS :has().
      var lab = r.closest('label');
      if (lab) lab.classList.toggle('is-on', r.checked);
    });
  }

  /* Счётчик количества темы скрыт правилом :has(). Там, где :has() нет,
     прячем его же обычным способом. */
  function hideQtySelector() {
    var i = qtyInput();
    var w = i && i.closest('.quantity-selector-wrapper');
    if (w) w.style.display = 'none';
  }

  function slider(key, v) {
    return '<div class="whs7-sl" data-key="' + key + '">'
      + '<button type="button" data-step="-8" aria-label="' + TH('smaller') + '">&minus;</button>'
      + '<input type="range" min="0" max="100" step="1" value="' + v + '" aria-label="' + TH('text_size') + '">'
      + '<button type="button" data-step="8" aria-label="' + TH('bigger') + '">+</button>'
      + '</div>'
      + '<div class="whs7-pct"><span data-pct>' + Math.round(v) + '%</span></div>';
  }

  function panelHTML(i) {
    var s = st[i], m = multi(), q = function (t) { return String(t).replace(/"/g, '&quot;'); };
    var h = '<div class="whs7-set" data-i="' + i + '">';
    if (m) {
      h += '<div class="whs7-setttl">' + TH('set_n', { n: i + 1 }) + (i === 0 ? ' &middot; ' + TH('your_text') : '') + '</div>';
      if (i > 0) {
        h += '<div class="whs7-mode">'
           + '<button type="button" data-mode="text"' + (s.mode === 'text' ? ' class="is-on"' : '') + '>' + TH('personalize') + '</button>'
           + '<button type="button" data-mode="logo"' + (s.mode === 'logo' ? ' class="is-on"' : '') + '>' + TH('keep_logo') + '</button>'
           + '</div>';
      }
    }
    if (i > 0 && s.mode === 'logo') return h + '</div>';

    var esc = function (t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); };
    var AL = { left: '<path d="M1 2h14M1 6h9M1 10h12"/>', center: '<path d="M1 2h14M3.5 6h9M2 10h12"/>', right: '<path d="M1 2h14M6 6h9M3 10h12"/>' };
    var alBtn = function (a, label) {
      return '<button type="button" data-al="' + a + '" aria-label="' + label + '" aria-pressed="' + (s.al === a) + '"' + (s.al === a ? ' class="is-on"' : '') + '>'
        + '<svg viewBox="0 0 16 12" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">' + AL[a] + '</svg></button>';
    };
    h += '<div class="whs7-row"><span class="whs7-lbl">' + TH('your_text') + '</span><span class="whs7-cnt" data-cnt="1"></span></div>'
       + '<textarea class="whs7-field" dir="auto" data-f="txt" rows="2" wrap="off" placeholder="' + TH('placeholder_1') + '&#10;' + TH('placeholder_2') + '" autocomplete="off" spellcheck="false" aria-label="' + TH('aria_text') + '">' + esc(areaText(s)) + '</textarea>'
       + '<div class="whs7-note">' + TH('note', { lines: MAXLINES, max: MAX }) + '</div>'
       + '<div class="whs7-al"><span class="whs7-lbl">' + TH('align') + '</span>' + alBtn('left', TH('align_left')) + alBtn('center', TH('align_center')) + alBtn('right', TH('align_right')) + '</div>'
       + slider('v1', s.v1);
    h += '<div class="whs7-hint" data-hint></div>'
       + '<button type="button" class="whs7-egtoggle" data-egtoggle><span>' + TH('idea') + '</span><span>' + (s.eg ? '&minus;' : '+') + '</span></button>'
       + '<div class="whs7-eg-row"' + (s.eg ? '' : ' hidden') + '>';
    IDEAS.forEach(function (p) {
      h += '<button type="button" data-eg="' + q(p[0]) + '"'
         + (p[1] ? ' data-eg2="' + q(p[1]) + '"' : '')
         + ' data-egal="' + q(p[2] || 'center') + '">'
         + esc(p[0] + (p[1] ? ' ' + p[1] : '')) + '</button>';
    });
    h += '</div>';
    var F0 = fontOf(s), foOpen = s.fo !== false;
    h += '<button type="button" class="whs7-egtoggle" data-fotoggle><span>' + TH('font') + '</span><span>' + (foOpen ? '&minus;' : '+') + '</span></button>'
       + '<div class="whs7-fo-row"' + (foOpen ? '' : ' hidden') + '>';
    FONTS.forEach(function (F) {
      var sel = F.id === F0.id;
      h += '<button type="button" data-font="' + F.id + '" aria-pressed="' + sel + '"' + (sel ? ' class="is-on"' : '') + '>'
         + '<span class="whs7-fo-s" style="font-family:' + q(fontCss(F)) + ';font-style:' + F.style + ';font-weight:' + F.weight + '">Aa</span>'
         + '<span class="whs7-fo-n">' + TH('font_' + F.id) + '</span></button>';
    });
    h += '</div>'
       + '<div class="whs7-prev" data-prev><img src="' + IMG + '" alt="' + TH('preview_alt') + '" loading="lazy">'
       + '<div class="whs7-pvtext"><span data-pv="1" dir="auto"></span><span data-pv="2" dir="auto"></span></div></div>'
       + '<div class="whs7-edge">' + TH('edge') + '</div>';
    return h + '</div>';
  }

  function build() {
    var n = panels(), h = '';
    for (var i = 0; i < n; i++) h += panelHTML(i);
    wrap.innerHTML = h;
    lastKey = n * 100 + (multi() ? 1 : 0);
    paintAll();
    watchPreviews();
  }
  function rebuildIfNeeded() {
    var key = panels() * 100 + (multi() ? 1 : 0);
    if (key !== lastKey) build(); else paintAll();
  }

  function fit(panel) {
    var prev = panel.querySelector('[data-prev]');
    var tw = panel.querySelector('.whs7-pvtext');
    if (!prev || !tw) return;
    /* Панель могла только что перерисоваться (например, текст подставили кнопкой-подсказкой),
       и размеры ещё не посчитаны. Раньше здесь был выход — и надпись оставалась без размера,
       а значит обрезалась многоточием. Теперь пробуем ещё раз, пока размеры не появятся. */
    if (!prev.clientWidth || !tw.clientWidth || !prev.clientHeight) {
      var tries = Number(panel.getAttribute('data-fit-try') || 0);
      if (tries < 30) {
        panel.setAttribute('data-fit-try', tries + 1);
        window.setTimeout(function () { if (panel.isConnected) fit(panel); }, 100);
      }
      return;
    }
    panel.setAttribute('data-fit-try', 0);
    var i = Number(panel.getAttribute('data-i')), s = st[i];
    var wk = fontOf(s).wk;
    var boxW = (tw.clientWidth || 200) * wk;
    var boxH = prev.clientHeight * BOXH;
    var e1 = panel.querySelector('[data-pv="1"]');
    var e2 = panel.querySelector('[data-pv="2"]');
    var two = !!(s.hasL2 && s.l2);
    var maxB = boxH * (two ? 0.46 : 0.80) * fontOf(s).k;
    tw.style.textAlign = s.al || 'center';
    /* Считаем размер пропорцией за один шаг: ширина текста растёт линейно с кеглем.
       Шаги по 5% с потолком в 40 итераций не дотягивали на длинных надписях, и хвост
       обрезался многоточием. Несколько контрольных шагов — на округления шрифта. */
    /* scrollWidth у строки-блока не бывает меньше ширины самого поля, поэтому для шрифтов
       с запасом по ширине (wk < 1) меряем сам текст через Range. */
    function textW(el) {
      if (wk < 1) {
        try {
          var r = document.createRange();
          r.selectNodeContents(el);
          var rw = r.getBoundingClientRect().width;
          if (rw > 0) return rw;
        } catch (err) {}
        return el.scrollWidth * wk;
      }
      return el.scrollWidth;
    }
    function shrinkW(el, size) {
      el.style.fontSize = size.toFixed(2) + 'px';
      var w = textW(el);
      if (w > boxW && w > 0) {
        size = Math.max(4, size * (boxW / w));
        el.style.fontSize = size.toFixed(2) + 'px';
      }
      var g = 0;
      while (textW(el) > boxW && size > 4 && g < 20) { size *= 0.97; el.style.fontSize = size.toFixed(2) + 'px'; g++; }
      return size;
    }
    /* Сначала ищем самый крупный размер, который ещё помещается по ширине,
       потом сжимаем по высоте поля — это и есть 100% ползунка. */
    var m1 = shrinkW(e1, maxB), m2 = 0;
    if (e2) {
      e2.style.display = two ? 'block' : 'none';
      if (two) m2 = shrinkW(e2, maxB);
    }
    var fMax = two ? Math.min(m1, m2) : m1;
    var totalMax = fMax * 1.15 * (two ? 2 : 1);
    if (totalMax > boxH) fMax *= boxH / totalMax;

    var f = fMax * frac(s.v1);
    e1.style.fontSize = f.toFixed(2) + 'px';
    if (e2 && two) e2.style.fontSize = f.toFixed(2) + 'px';

    var pct = panel.querySelector('[data-pct]');
    if (pct) pct.textContent = Math.round(Math.max(0, Math.min(100, s.v1))) + '%';
  }

  function paintPanel(panel) {
    var i = Number(panel.getAttribute('data-i')), s = st[i];
    var c1 = panel.querySelector('[data-cnt="1"]');
    var c2 = panel.querySelector('[data-cnt="2"]');
    if (c1) {
      var n1 = clen(s.l1), n2 = clen(s.l2);
      c1.textContent = s.hasL2 ? n1 + ' / ' + MAX + '  \u00b7  ' + n2 + ' / ' + MAX : n1 + ' / ' + MAX;
      c1.classList.toggle('is-max', n1 >= MAX || n2 >= MAX);
    }
    var p1 = panel.querySelector('[data-pv="1"]');
    var p2 = panel.querySelector('[data-pv="2"]');
    if (p1) { p1.textContent = s.l1.trim() ? s.l1 : T('text_here'); p1.style.opacity = s.l1.trim() ? '1' : '.35'; }
    if (p2) p2.textContent = s.hasL2 ? s.l2 : '';
    var F = fontOf(s);
    [p1, p2].forEach(function (p) {
      if (!p) return;
      p.style.fontFamily = fontCss(F);
      p.style.fontStyle = F.style;
      p.style.fontWeight = F.weight;
    });
    fit(panel);
  }

  function engFee() { return (on.checked && qty() === 1 && !giftOn()) ? FEE_C : 0; }

      function nearNote(show, text) {
    var el = document.getElementById('whs7-limit-near');
    if (!show) { if (el) el.hidden = true; return; }
    if (!el) {
      var f = productForm();
      if (!f) return;
      el = document.createElement('div');
      el.id = 'whs7-limit-near';
      el.className = 'whs7-limit-near';
      f.insertAdjacentElement('afterend', el);
    }
    el.textContent = text;
    el.hidden = false;
    }

  /* Отмечаем ту карточку, которая соответствует текущему состоянию гравировки —
     нужно при восстановлении черновика и при любом изменении чекбокса. */
  function syncPick() {
    var want = on.checked ? 'engraved' : 'plain';
    box6.querySelectorAll('input[name="whs6-pick"]').forEach(function (r) {
      r.checked = (r.value === want);
    });
  }

  function paintPrice() {
    syncPick();
    var lim = box7.querySelector('[data-whs7-limit]');
    var LIMTXT = T('limit', { n: MAXSETS });
    if (on.checked && qty() > MAXSETS) {
      setQty(MAXSETS);
      if (lim) { lim.textContent = LIMTXT; lim.hidden = false; }
      nearNote(true, LIMTXT);
    } else if (qty() < MAXSETS || !on.checked) {
      if (lim) lim.hidden = true;
      nearNote(false);
    }
    var n = qty();
    var disc = n >= 3 ? OFF3 : (n >= 2 ? OFF2 : 0);
    var base = UNIT * n - disc;
    var add = engFee(); // реальная доплата за гравировку (только n===1)
    var current = base + add; // реальная цена к оплате
    // "Ценность" для зачёркивания: наборы по полной (compare-at) цене
    // плюс опубликованная цена гравировки за каждый набор, если она включена.
    var setsValue = (CMP1 > UNIT ? CMP1 : UNIT) * n;
    var engValue = on.checked ? ENG_COMPARE_PER_SET_C * n : 0;
    var totalValue = setsValue + engValue;
    var root = scope();
    root.querySelectorAll('.price-item--sale.price, .price__regular .price').forEach(function (e) {
      if (box6.contains(e) || box7.contains(e)) return;
      e.textContent = money(current);
    });
    root.querySelectorAll('.compare-at-price').forEach(function (e) {
      if (box6.contains(e) || box7.contains(e)) return;
      e.textContent = (totalValue > current) ? money(totalValue, true) : '';
    });
    var over = tooMany();
    if (over && on.checked) { on.checked = false; box7.classList.remove('is-on'); }
    on.disabled = over;
    if (head) head.style.opacity = over ? '.55' : '';
    if (fee) {
      if (over) fee.innerHTML = '<span class="whs7-free">' + TH('up_to_sets', { n: MAXSETS }) + '</span>';
      else if (n >= 2 || giftOn()) fee.innerHTML = '<s>' + money(ENG_COMPARE_PER_SET_C * n, true) + '</s><span class="whs7-free">' + TH('free') + '</span>';
      // Платная гравировка на один набор: зачёркивать нечего — «было» равно цене, которую человек платит.
      else fee.innerHTML = '+' + money(FEE_C, true);
    }
    // Подсказка про бесплатную гравировку нужна только тому, кто ещё выбирает один набор.
    var freeHint = ensureFreeHint();
    if (freeHint) freeHint.hidden = (n >= 2 || over || giftOn());
    if (diffW) diffW.hidden = !(on.checked && n >= 2 && !over);
  }

  function validate() {
    var btn = submitBtn(), msg = '';
    if (on.checked) {
      var n = panels();
      for (var i = 0; i < n; i++) {
        if (i > 0 && st[i].mode !== 'text') continue;
        if (!st[i].l1.trim()) { msg = n > 1 ? T('enter_text_set', { n: i + 1 }) : T('enter_text'); break; }
      }
      if (!msg && !okcb.checked) msg = CMSG;
    }
    if (blk) blk.textContent = msg;
    nearNote(!!msg, msg);
    // Галочка подтверждения мигает, когда осталась только она.
    var okw = okcb.closest('.whs7-ok');
    if (okw) okw.classList.toggle('is-wait', on.checked && !okcb.checked && msg === CMSG);
    if (btn) {
      btn.disabled = !!msg;
      btn.style.opacity = msg ? '.5' : '';
      btn.style.cursor = msg ? 'not-allowed' : '';
    }
    return !msg;
  }

  function paintAll() {
    syncFormOwner();
    syncRadios();
    wrap.querySelectorAll('.whs7-set').forEach(paintPanel);
    paintPrice();
    validate();
    save();
  }

  wrap.addEventListener('input', function (e) {
    var panel = e.target.closest('.whs7-set');
    if (!panel) return;
    var i = Number(panel.getAttribute('data-i'));
    var sl = e.target.closest('.whs7-sl');
    if (sl) { st[i][sl.getAttribute('data-key')] = Number(e.target.value); fit(panel); save(); return; }
    var f = e.target.getAttribute('data-f');
    if (f !== 'txt') return;
    var before = e.target.value, pos = e.target.selectionStart, atEnd = pos === before.length;
    var w = wrapText(before), after = w.lines.join('\n');
    if (after !== before) {
      e.target.value = after;
      var np = atEnd ? after.length : Math.min(pos, after.length);
      try { e.target.setSelectionRange(np, np); } catch (err) {}
    }
    var h = panel.querySelector('[data-hint]');
    if (h) h.textContent = w.cut ? T('hint_lines', { lines: MAXLINES, max: MAX }) : '';
    st[i].l1 = w.lines[0] || '';
    st[i].hasL2 = w.lines.length > 1;
    st[i].l2 = st[i].hasL2 ? w.lines[1] : '';
    paintPanel(panel);
    paintPrice();
    validate();
    save();
  });

  // Третью строку не даём: Enter на второй строке ничего не делает.
  wrap.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('textarea[data-f="txt"]')) return;
    if (e.target.value.split('\n').length >= MAXLINES) e.preventDefault();
  });

  wrap.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    var panel = b.closest('.whs7-set');
    if (!panel) return;
    var i = Number(panel.getAttribute('data-i'));
    if (b.hasAttribute('data-step')) {
      var sl = b.closest('.whs7-sl'), key = sl.getAttribute('data-key');
      var v = Math.max(0, Math.min(100, st[i][key] + Number(b.getAttribute('data-step'))));
      st[i][key] = v;
      sl.querySelector('input').value = v;
      fit(panel); save();
      return;
    }
    if (b.hasAttribute('data-egtoggle')) {
      st[i].eg = !st[i].eg;
      var row = panel.querySelector('.whs7-eg-row');
      if (row) row.hidden = !st[i].eg;
      var ic = b.querySelector('span:last-child');
      if (ic) ic.innerHTML = st[i].eg ? '&minus;' : '+';
      return;
    }
    if (b.hasAttribute('data-fotoggle')) {
      st[i].fo = st[i].fo === false;
      var frow = panel.querySelector('.whs7-fo-row');
      if (frow) frow.hidden = !st[i].fo;
      var fic = b.querySelector('span:last-child');
      if (fic) fic.innerHTML = st[i].fo ? '&minus;' : '+';
      save();
      return;
    }
    if (b.hasAttribute('data-font')) {
      st[i].font = b.getAttribute('data-font');
      panel.querySelectorAll('[data-font]').forEach(function (x) {
        var sel = x === b;
        x.classList.toggle('is-on', sel);
        x.setAttribute('aria-pressed', String(sel));
      });
      paintPanel(panel); save();
      // шрифт мог ещё не скачаться — после загрузки ширина текста другая, размер пересчитываем
      if (document.fonts && document.fonts.load) {
        document.fonts.load(fontLoadSpec(fontOf(st[i])), 'Aa' + st[i].l1 + st[i].l2)
          .then(function () { if (panel.isConnected) fit(panel); }).catch(function () {});
      }
      return;
    }
    if (b.hasAttribute('data-mode')) { st[i].mode = b.getAttribute('data-mode'); build(); return; }
    if (b.hasAttribute('data-al')) {
      st[i].al = b.getAttribute('data-al');
      panel.querySelectorAll('[data-al]').forEach(function (x) {
        var sel = x === b;
        x.classList.toggle('is-on', sel);
        x.setAttribute('aria-pressed', String(sel));
      });
      fit(panel); save();
      return;
    }
    if (b.hasAttribute('data-eg')) {
      st[i].l1 = clean(b.getAttribute('data-eg'));
      var two = b.getAttribute('data-eg2');
      st[i].hasL2 = !!two;
      st[i].l2 = two ? clean(two) : '';
      st[i].al = b.getAttribute('data-egal') || 'center';
      st[i].v1 = 100;  // новая надпись — снова самый крупный размер
      // список идей не закрываем: человек может перебирать варианты подряд
      build(); return;
    }
  });

  on.addEventListener('change', function () {
    box7.classList.toggle('is-on', on.checked);
    if (!on.checked) {
      st = []; for (var z = 0; z < MAXSETS; z++) st.push(fresh());
      okcb.checked = false; diff.checked = false;
    }
    build();
  });
  diff.addEventListener('change', build);
  okcb.addEventListener('change', function () { validate(); save(); });

  box6.addEventListener('change', function (e) {
    /* С 30.09.2026 карточки выбирают не количество наборов, а гравировку:
       «The Complete Set» или «With your engraving». Радиокнопка переключает
       тот же чекбокс #whs7-on, на котором держится вся остальная логика. */
    if (e.target && e.target.name === 'whs6-pick') {
      var wantEng = e.target.value === 'engraved';
      if (on.checked !== wantEng) {
        on.checked = wantEng;
        on.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  function onQtyMaybeChanged() { window.setTimeout(rebuildIfNeeded, 0); }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('quantity-selector-component, .quantity-selector')) onQtyMaybeChanged();
  });
  ['input', 'change', 'blur', 'keyup'].forEach(function (t) {
    document.addEventListener(t, function (e) {
      if (e.target && e.target.name === 'quantity' && !box6.contains(e.target) && !box7.contains(e.target)) onQtyMaybeChanged();
    }, true);
  });
  function refitAll() { wrap.querySelectorAll('.whs7-set').forEach(fit); }

  /* Страховка: следим за самим превью. Любое изменение его размеров — поворот экрана,
     сворачивание панели браузера, подгрузка картинок выше по странице — пересчитывает
     размер надписи. Иначе текст, подобранный под старую ширину, обрезается многоточием. */
  var ro = null;
  if (window.ResizeObserver) {
    ro = new ResizeObserver(function (entries) {
      entries.forEach(function (en) {
        var p = en.target.closest ? en.target.closest('.whs7-set') : null;
        if (p) fit(p);
      });
    });
  }
  function watchPreviews() {
    // Фото ручки могло прийти из кэша: события load не будет, размеры есть сразу.
    wrap.querySelectorAll('[data-prev] img').forEach(function (im) {
      if (im.complete) { var p = im.closest('.whs7-set'); if (p) fit(p); }
    });
    if (!ro) return;
    try { ro.disconnect(); } catch (e) {}
    wrap.querySelectorAll('[data-prev]').forEach(function (el) { ro.observe(el); });
  }

  /* ResizeObserver зависит от отрисовки кадров и в некоторых условиях молчит.
     Поэтому раз в секунду просто сверяем ширину поля с той, под которую считали
     размер надписи: изменилась — пересчитываем. Это одна операция чтения. */
  window.setInterval(function () {
    if (!on.checked) return;
    wrap.querySelectorAll('.whs7-set').forEach(function (p) {
      var tw = p.querySelector('.whs7-pvtext');
      var e1 = p.querySelector('[data-pv="1"]');
      if (!tw || !e1) return;
      var w = tw.clientWidth;
      var cut = e1.scrollWidth > e1.clientWidth + 1;   // текст не помещается
      var unsized = !e1.style.fontSize;                 // размер так и не посчитали
      if (cut || unsized || (w && w !== Number(p.getAttribute('data-fit-w') || 0))) {
        p.setAttribute('data-fit-w', w);
        fit(p);
      }
    });
  }, 700);
  ['orientationchange', 'pageshow'].forEach(function (ev) { window.addEventListener(ev, refitAll); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refitAll(); });
  window.addEventListener('resize', refitAll);
  /* Пока фото ручки не загрузилось, у превью нет высоты, а пока не загрузился шрифт —
     ширина текста другая. В обоих случаях размер надо пересчитать. */
  wrap.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'IMG') { var p = e.target.closest('.whs7-set'); if (p) fit(p); }
  }, true);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(refitAll).catch(function () {});
    if (document.fonts.load) {
      document.fonts.load('italic 600 40px "Cormorant Garamond"', 'Aa').then(refitAll).catch(function () {});
    }
  }


  // Файлы гравировки: фото ручки с текстом (preview) и чёрный текст на белом (artwork, для фабрики).
  var CXP = 0.5055, CYP = 0.4859, TBW = 0.3603, BOXHR = 0.339;
  var BASE_W = 1002, BASE_H = 354;
  var PROOF_SCALE = 0.75, ART_SCALE = 1.5, PROOF_QUALITY = 0.62; // ART_SCALE снижен с 5 до 2 — при 5 холст выходил 5010x1770 и генерация занимала 15-20с на набор
  var woodImg = null, woodDone = false;

  function loadWood() {
    if (woodDone) return Promise.resolve(woodImg);
    return new Promise(function (res) {
      if (!IMG) { woodDone = true; return res(null); }
      var i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = function () { woodImg = i; woodDone = true; res(i); };
      i.onerror = function () { woodDone = true; res(null); };
      i.src = IMG;
    });
  }

  function loadFonts() {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    // Текст-образец нужен, чтобы Google Fonts подгрузил и латиницу, и кириллицу, и расширенную латиницу.
    // Значки (♥ ★ ∞) и эмодзи берутся из монохромных шрифтов — на станке нужен контур, а не цветная картинка.
    var used = {};
    st.forEach(function (s) { if (s.l1) used[fontOf(s).id] = 1; });
    var jobs = FONTS.filter(function (F) { return used[F.id] || F.id === 'classic'; }).map(function (F) {
      return [fontLoadSpec(F), 'Aa Яя Éé Ąą'];
    }).concat([
      ['italic 600 40px "Noto Sans Symbols 2"', '\u2665\u2605\u221e\u2740'],
      ['italic 600 40px "Noto Emoji"', '\ud83d\ude00\u2764'],
      ['italic 600 40px "Noto Sans"', 'Aa'],
      ['italic 600 40px "Noto Sans Arabic"', '\u0627']
    ]).map(function (f) {
      var sample = f[1];
      // каждый символ, который реально ввели, тоже подгружаем — Google режет шрифты на части
      st.forEach(function (s) { sample += (s.l1 || '') + (s.l2 || ''); });
      return document.fonts.load(f[0], sample).catch(function () {});
    });
    return Promise.all(jobs).then(function () { return document.fonts.ready; }).catch(function () {});
  }

  function fspec(sz, s) { var F = fontOf(s); return F.style + ' ' + F.weight + ' ' + sz.toFixed(2) + 'px ' + fontCss(F); }

  /* Повторяет расчёт fit(): те же пропорции, что покупатель видел на экране. */
  function measureText(ctx, W, H, s, scale) {
    var boxW = W * TBW, boxH = H * BOXHR;
    var two = !!(s.hasL2 && s.l2);
    var maxB = boxH * (two ? 0.46 : 0.80) * fontOf(s).k;
    var fitW = boxW * fontOf(s).wk;
    function shrink(t, sz) {
      ctx.font = fspec(sz, s);
      var w = ctx.measureText(t).width;
      if (w > fitW && w > 0) { sz = Math.max(4 * scale, sz * (fitW / w)); ctx.font = fspec(sz, s); }
      var g = 0;
      while (ctx.measureText(t).width > fitW && sz > 4 * scale && g < 20) { sz *= 0.97; ctx.font = fspec(sz, s); g++; }
      return sz;
    }
    var m1 = shrink(s.l1, maxB);
    var m2 = two ? shrink(s.l2, maxB) : 0;
    var fMax = two ? Math.min(m1, m2) : m1;
    var totalMax = fMax * 1.15 * (two ? 2 : 1);
    if (totalMax > boxH) fMax *= boxH / totalMax;
    var f = fMax * frac(s.v1);
    return { f1: f, f2: two ? f : 0, two: two, boxW: boxW, boxH: boxH };
  }

  function paintText(ctx, s, L, cx, cy, color) {
    var al = s.al === 'left' || s.al === 'right' ? s.al : 'center';
    ctx.textAlign = al;
    // левый/правый край поля; курсив чуть выступает вправо — оставляем запас
    if (al === 'left') cx -= L.boxW / 2 - L.f1 * 0.05;
    if (al === 'right') cx += L.boxW / 2 - L.f1 * 0.15;
    ctx.textBaseline = 'middle';
    ctx.fillStyle = color;
    var totalH = L.f1 * 1.15 + (L.two ? L.f2 * 1.15 : 0);
    var top = cy - totalH / 2;
    ctx.font = fspec(L.f1, s);
    ctx.fillText(s.l1, cx, top + L.f1 * 1.15 / 2);
    if (L.two) {
      ctx.font = fspec(L.f2, s);
      ctx.fillText(s.l2, cx, top + L.f1 * 1.15 + L.f2 * 1.15 / 2);
    }
  }

  function toBlob(canvas, type, q) {
    return new Promise(function (res) {
      try { canvas.toBlob(function (b) { res(b); }, type, q); }
      catch (e) { res(null); }
    });
  }

  /* Фото ручки с текстом — то, что покупатель видел в превью. */
  function makeProof(s) {
    if (!woodImg) return Promise.resolve(null);
    try {
      var W = BASE_W * PROOF_SCALE, H = BASE_H * PROOF_SCALE;
      var c = document.createElement('canvas');
      c.width = W; c.height = H;
      var x = c.getContext('2d');
      x.drawImage(woodImg, 0, 0, W, H);
      var L = measureText(x, W, H, s, PROOF_SCALE);
      paintText(x, s, L, W * CXP, H * CYP, 'rgba(46,26,10,.92)');
      return toBlob(c, 'image/jpeg', PROOF_QUALITY);
    } catch (e) { return Promise.resolve(null); }
  }

  /* Чёрный текст на белом, обрезано ровно по полю гравировки. */
  function makeArtwork(s) {
    try {
      var W = BASE_W * ART_SCALE, H = BASE_H * ART_SCALE;
      var probe = document.createElement('canvas').getContext('2d');
      var L = measureText(probe, W, H, s, ART_SCALE);
      var AW = Math.round(L.boxW), AH = Math.round(L.boxH);
      var c = document.createElement('canvas');
      c.width = AW; c.height = AH;
      var x = c.getContext('2d');
      x.fillStyle = '#ffffff';
      x.fillRect(0, 0, AW, AH);
      paintText(x, s, L, AW / 2, AH / 2, '#000000');
      return toBlob(c, 'image/png');
    } catch (e) { return Promise.resolve(null); }
  }

  var WAIT_NOTE = TH('wait');
  var busyGuard = null;

  // Строка про доставку под кнопкой.
  // С 30.09.2026 экспресса на чекауте нет: один бесплатный тариф. Сроки — как в FAQ и Shipping policy.
  var SHIP_LINE_HTML = '<b>' + TH('ship_b') + '</b>' + '<em>' + TH('ship_em') + '</em>';
  function addShipLine() {
    if (document.getElementById('whs7-ship')) return;
    var f = productForm();
    if (!f) return;
    var el = document.createElement('div');
    el.id = 'whs7-ship';
    el.className = 'whs7-ship';
    el.innerHTML = SHIP_LINE_HTML;
    f.insertAdjacentElement('afterend', el);
  }

  /* Ссылка на страницу-адверториал. Текстовая, с подчёркиванием —
     она не должна конкурировать с кнопкой Add to cart. */
  var ADV_TEXT = T('adv');
  var ADV_HREF = ROOT + 'pages/why-solid-wood?ref=pdp';
  function addAdvLink() {
    if (document.getElementById('whs7-adv')) return;
    var after = document.getElementById('whs7-ship') || productForm();
    if (!after) return;
    var el = document.createElement('div');
    el.id = 'whs7-adv';
    el.className = 'whs7-adv';
    var a = document.createElement('a');
    a.href = ADV_HREF;
    a.textContent = ADV_TEXT;
    el.appendChild(a);
    after.insertAdjacentElement('afterend', el);
  }

  /* Подсказку строим на клиенте: редактор Custom Liquid вырезает из
     разметки теги с пустыми data-атрибутами и склеивает соседние блоки. */
  function ensureFreeHint() {
    /* С 30.09.2026 лестницы наборов нет: продаём один набор, гравировка платная.
       Подсказка «бесплатно от двух» больше не нужна, и старую, если она
       осталась в сохранённой разметке, убираем. */
    var old = document.getElementById('whs7-freehint');
    if (old) old.remove();
    return null;
  }

  function syncFormOwner() {
    var f = productForm();
    if (!f) return;
    if (on.checked) f.setAttribute('data-wh-skip', '');
    else f.removeAttribute('data-wh-skip');
  }

  function showProg(msg) {
    if (prog) {
      if (msg) { prog.textContent = msg; prog.hidden = false; }
      else { prog.hidden = true; prog.textContent = ''; }
    }
    var near = document.getElementById('whs7-busy');
    if (!msg) {
      if (near) near.hidden = true;
      if (busyGuard) { window.removeEventListener('beforeunload', busyGuard); busyGuard = null; }
      return;
    }
    if (!near) {
      var f = productForm();
      if (!f) return;
      near = document.createElement('div');
      near.id = 'whs7-busy';
      near.className = 'whs7-busy';
      near.setAttribute('role', 'status');
      near.setAttribute('aria-live', 'polite');
      f.insertAdjacentElement('afterend', near);
    }
    near.innerHTML = '<b><i></i>' + escH(msg) + '</b>' + WAIT_NOTE;
    near.hidden = false;
    if (!busyGuard) {
      busyGuard = function (e) { e.preventDefault(); e.returnValue = ''; return ''; };
      window.addEventListener('beforeunload', busyGuard);
    }
  }

  /* Корзина могла залипнуть из-за страны, куда мы не возим: тогда Shopify отвечает
     «already sold out». Сбрасываем корзину (wh-cart.js) и пробуем ещё раз. */
  function postWithRecovery(init) {
    return fetch(ROOT + 'cart/add.js', init).then(function (r) {
      if (r.ok) return r.json();
      if (window.whResetCart) window.whResetCart();
      return fetch(ROOT + 'cart/add.js', init).then(function (r2) {
        if (!r2.ok) throw new Error('add failed');
        return r2.json();
      });
    });
  }

  /* Вся корзина одним запросом. Если есть файлы — FormData, иначе JSON. */
  function addAll(plan) {
    var anyFile = plan.some(function (it) { return it.files && (it.files.proof || it.files.artwork); });
    if (!anyFile) {
      var items = plan.map(function (it) {
        var o = { id: it.id, quantity: it.quantity };
        if (it.props && Object.keys(it.props).length) o.properties = it.props;
        return o;
      });
      return postWithRecovery({
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'wh-cart-drawer' })
      });
    }
    var fd = new FormData();
    fd.append('sections', 'wh-cart-drawer'); // корзина вернётся уже отрисованной
    plan.forEach(function (it, i) {
      var k = 'items[' + i + ']';
      fd.append(k + '[id]', String(it.id));
      fd.append(k + '[quantity]', String(it.quantity));
      Object.keys(it.props || {}).forEach(function (name) {
        fd.append(k + '[properties][' + name + ']', it.props[name]);
      });
      if (it.files && it.files.proof) {
        fd.append(k + '[properties][Engraving preview]', it.files.proof, 'engraving-preview.jpg');
      }
      if (it.files && it.files.artwork) {
        fd.append(k + '[properties][_Engraving artwork]', it.files.artwork, 'engraving-artwork.png');
      }
    });
    return postWithRecovery({ method: 'POST', headers: { Accept: 'application/json' }, body: fd });
  }

  function pct(v) { return Math.round(v) + '%'; }
  function props(i) {
    var s = st[i], o = {};
    if (i > 0 && s.mode !== 'text') { o['Engraving'] = 'Our logo, no personal text'; return o; }
    if (!s.l1) return null;
    o['Engraving \u2014 Line 1'] = s.l1;
    o['_Engraving \u2014 Line 1 size'] = pct(s.v1);
    if (s.hasL2 && s.l2) o['Engraving \u2014 Line 2'] = s.l2;
    o['Engraving \u2014 Font'] = fontOf(s).name;
    o['_Engraving \u2014 Font family'] = fontOf(s).fam + (fontOf(s).style === 'italic' ? ' Italic' : '') + ' ' + fontOf(s).weight;
    o['Engraving \u2014 Alignment'] = s.al === 'left' ? 'Left' : (s.al === 'right' ? 'Right' : 'Center');
    return o;
  }

  /* Слушаем на window в фазе погружения: window идёт в цепочке событий раньше
     document, а Horizon вешает свой обработчик отправки формы на document.
     Раньше этот скрипт был inline и успевал зарегистрироваться первым; теперь он
     подключается файлом и грузится позже темы, поэтому только window спасает.
     Иначе тема добавляет набор сама, без текста гравировки. */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f !== productForm() || !on.checked) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (!validate()) return;

    var n = qty();

    /* Позиции заказа: у каждой свой текст и свои картинки. */
    var plan = [];
    if (multi()) {
      for (var i = 0; i < n; i++) plan.push({ id: SET_ID, quantity: 1, state: st[i], props: props(i) });
    } else {
      plan.push({ id: SET_ID, quantity: n, state: st[0], props: props(0) });
    }

    var btn = submitBtn();
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    showProg(T('preparing'));

    function needsArt(it) {
      return it.state && it.state.l1 && !(it.props && it.props['Engraving']);
    }
    var artCount = plan.filter(needsArt).length;
    var made = 0;

    loadFonts()
      .then(loadWood)
      .then(function () {
        return Promise.all(plan.map(function (item) {
          if (!needsArt(item)) { item.files = null; return Promise.resolve(); }
          return Promise.all([makeProof(item.state), makeArtwork(item.state)]).then(function (out) {
            item.files = { proof: out[0], artwork: out[1] };
            made++;
            if (artCount > 1) showProg(T('preparing_n', { a: made, b: artCount }));
          });
        }));
      })
      .catch(function () { plan.forEach(function (it) { it.files = null; }); })
      .then(function () { return engReady; })
      .then(function () {
        /* Гравировка бесплатна при двух наборах и при подарке из окна.
           Если бесплатный вариант почему-то не загрузился — позицию не
           добавляем вовсе. Обещали бесплатно, значит списать $20 нельзя;
           текст гравировки всё равно уходит в свойствах самого набора. */
        var free = (n >= 2 || giftOn());
        var engPick = free ? ENG_FREE_ID : ENG_ID;
        if (engPick) {
          var engProps = (free && n < 2) ? { '_Offer': 'exit-window' } : null;
          plan.push({ id: engPick, quantity: 1, props: engProps, files: null });
        }
        showProg(T('adding'));
        return addAll(plan);
      })
      .then(function (added) {
        forget();
        if (added && added.sections && window.whApplyCartSections && window.whApplyCartSections(added.sections)) {
          showProg('');
          return;
        }
        /* Корзина открывается не мгновенно. Плашку снимаем только когда дровер
           открылся, иначе человек несколько секунд смотрит в пустоту. */
        showProg(T('opening'));
        var a = document.createElement('a');
        a.href = ROOT + 'cart'; a.style.display = 'none';
        document.body.appendChild(a); a.click();
        window.setTimeout(function () { a.remove(); }, 100);
        var n = 0;
        var wait = window.setInterval(function () {
          var d = document.querySelector('[data-wh-drawer]');
          if ((d && d.classList.contains('is-open')) || ++n > 40) { window.clearInterval(wait); showProg(''); }
        }, 250);
      })
      .catch(function () {
        showProg('');
        window.alert(T('ship_msg'));
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      });
  }, true);

  function restore() {
    var d = load();
    if (!d) return;
    if (d.qty) setQty(Math.min(Math.max(d.qty, 1), 99));
    if (d.on && !tooMany()) {
      on.checked = true; box7.classList.add('is-on');
      diff.checked = !!d.diff;
      okcb.checked = !!d.ok;
      if (d.st && d.st.length) {
        for (var i = 0; i < MAXSETS; i++) {
          var s = d.st[i] || {}, f = fresh();
          f.mode = s.mode === 'logo' ? 'logo' : 'text';
          f.l1 = clean(s.l1); f.l2 = clean(s.l2);
          f.v1 = Math.max(0, Math.min(100, Number(s.v1) || 100));
          f.v2 = Math.max(0, Math.min(100, Number(s.v2) || 100));
          f.hasL2 = !!s.hasL2;
          f.al = (s.al === 'left' || s.al === 'right') ? s.al : 'center';
          st[i] = f;
        }
      }
    }
  }

  function boot(t) {
    t = t || 0;
    if (!qtyInput() && t < 25) { setTimeout(function () { boot(t + 1); }, 150); return; }
    restore();
    syncFormOwner();
    addShipLine();
    addAdvLink();
    hideQtySelector();
    build();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(0); });
  else boot(0);
})();
